import type { Palette } from "@mui/material/styles";
import type { DocumentValidityStatus } from "web_myplann/Profile/Helpers/paperworkDocument";

type PaperworkValidityColors = {
	bg: string;
	text: string;
	dot: string;
	border: string;
};

export const getPaperworkValidityColors = (
	palette: Palette,
	status: DocumentValidityStatus,
): PaperworkValidityColors => {
	const colors: Record<DocumentValidityStatus, PaperworkValidityColors> = {
		valid: {
			bg: palette.green[50],
			text: palette.green[700],
			dot: palette.green[500],
			border: palette.green[200],
		},
		expiring: {
			bg: palette.orange[50],
			text: palette.orange[700],
			dot: palette.orange[600],
			border: palette.orange[200],
		},
		expired: {
			bg: palette.red[50],
			text: palette.red[700],
			dot: palette.red[500],
			border: palette.red[200],
		},
		none: {
			bg: palette.grey[50],
			text: palette.grey[500],
			dot: palette.grey[400],
			border: palette.grey[200],
		},
	};

	return colors[status];
};
